import React, {FC} from 'react';
import Card from '../../../../../components/layouts/card/card';
import FontBody1 from '../../../../../components/fonts/font-body1/font-body1';
import {FONT_COLOR, FONT_VARIANT} from '../../../../../components/fonts/font-props';
import {FormField} from '../../../../../components/form-field/form-field';
import ControlGroupWithPreview
	from '../../../../../components/layouts/control-group-with-preview/control-group-with-preview';
import fonts_and_colors_preview from '../../../../../images/previews/fonts-and-colors.svg';
import ColorPickerInput from '../../color-picker-input/color-picker-input';
import customizationStore from '../../../../../stores/customizations/customization-store';
import {Input} from '../../../../../components/inputs/input/input';
import ListLayout from '../../../../../components/layouts/list-layout/list-layout';
import { FormFieldLine } from '../../../../../components/form-field-line/form-field-line';
import {observer} from 'mobx-react';

interface IPortalClassicFontsAndColorsCardProps {
    isExpanded: boolean;
    onExpandedChange: (isExpanded: boolean) => void;
}

const PortalClassicFontsAndColorsCard: FC<IPortalClassicFontsAndColorsCardProps> = observer(({isExpanded, onExpandedChange}) => {
	const classicCustomizationStore = customizationStore.getClassicStore();

	return (
		<Card
			toolbar={{
				title: <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>Fonts and Colors</FontBody1>
			}}
			isExpanded={isExpanded}
			expandCallback={onExpandedChange}
		>
			<FormField
				label=''
				instructions='Customize your portal fonts and colors'
				children={null}
			/>
			<ControlGroupWithPreview
				hasTopBorder={false}
				gridStyle={{childrenWidth: {width: 1}, previewWidth: {width: 1}}}
				preview={<div className="preview"><img src={fonts_and_colors_preview} alt="" /></div>}
			>
				<ListLayout>
					<FormFieldLine label='Font'>
						<Input value={classicCustomizationStore.font} onChange={classicCustomizationStore.setFont} />
					</FormFieldLine>
					<FormFieldLine label='Title'>
						<ColorPickerInput value={classicCustomizationStore.titleColor} onChange={classicCustomizationStore.setTitleColor} />
					</FormFieldLine>
					<FormFieldLine label='Text'>
						<ColorPickerInput value={classicCustomizationStore.textColor} onChange={classicCustomizationStore.setTextColor} />
					</FormFieldLine>
					<FormFieldLine label='Input Text' >
						<ColorPickerInput value={classicCustomizationStore.inputTextColor} onChange={classicCustomizationStore.setInputTextColor} />
					</FormFieldLine>
					<FormFieldLine label='Input Background' >
						<ColorPickerInput value={classicCustomizationStore.inputBackgroundColor} onChange={classicCustomizationStore.setInputBackgroundColor} />
					</FormFieldLine>
					<FormFieldLine label='Button Background' >
						<ColorPickerInput value={classicCustomizationStore.buttonBackgroundColor} onChange={classicCustomizationStore.setButtonBackgroundColor} />
					</FormFieldLine>
					<FormFieldLine label='Button Text'>
						<ColorPickerInput value={classicCustomizationStore.buttonTextColor} onChange={classicCustomizationStore.setButtonTextColor} />
					</FormFieldLine>
					<FormFieldLine label='Errors Color'>
						<ColorPickerInput value={classicCustomizationStore.errorColor} onChange={classicCustomizationStore.setErrorColor} />
					</FormFieldLine>
				</ListLayout>
			</ControlGroupWithPreview>

		</Card>
	)
});

export default PortalClassicFontsAndColorsCard;
